<div class="validation-errors" *ngIf="type=='control'">
  <ng-container *ngFor="let validation of getFieldName">
    <div class="error-message text-danger"
      *ngIf="this.field.hasError(validation.type) && this.field.touched">
      {{ validation.message }}
    </div>
  </ng-container>
</div>

<div class="validation-errors" *ngIf="type=='group'">
  <ng-container *ngFor="let validation of getFieldName">
    <div class="error-message text-danger"
      *ngIf="formName.get(this.fieldName)!.hasError(validation.type) && (formName.get(this.fieldName)!.touched)">
      {{ validation.message }}
    </div>
  </ng-container>
</div>
